import { render, staticRenderFns } from "./Ecosystems.vue?vue&type=template&id=160c0600&scoped=true"
import script from "./Ecosystems.vue?vue&type=script&setup=true&lang=js"
export * from "./Ecosystems.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c0600",
  null
  
)

export default component.exports